import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { ControllerWithCommandServiceBase } from '../controller-with-command-service-base';
import { PageContainerService } from '../../../services';
import { faChevronDown, faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

@Component({
  standalone: false,
  selector: 'header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  faChevronLeft = faChevronLeft;
  faChevronRight = faChevronRight;
  faChevronDown = faChevronDown;

  userMenuOpen = false;

  @Input() isSidebarCollapsed: boolean = false;
  @Output() sidebarToggle = new EventEmitter<boolean>();

  constructor(public pcs: PageContainerService) {
  }

  ngOnInit() {
    const collapsed = localStorage.getItem('globalSidebarCollapsed');
    if (collapsed !== null) {
      this.isSidebarCollapsed = collapsed === 'true';
    }
  }

  get loggedIn(): boolean {
    return this.pcs.clientSessionService.loggedIn;
  }

  get displayName(): string {
    const first = this.pcs.clientSessionService.firstName || '';
    const last = this.pcs.clientSessionService.lastName || '';
    const full = `${first} ${last}`.trim();
    return full || this.pcs.clientSessionService.userName || 'User';
  }

  get userInitials(): string {
    const first = this.pcs.clientSessionService.firstName || '';
    const last = this.pcs.clientSessionService.lastName || '';
    if (first || last) {
      return `${(first[0] || '')}${(last[0] || '')}`.toUpperCase();
    }
    const userName = this.pcs.clientSessionService.userName || 'U';
    return userName.slice(0, 2).toUpperCase();
  }

  toggleUserMenu(event?: MouseEvent) {
    if (event) {
      event.stopPropagation();
    }
    this.userMenuOpen = !this.userMenuOpen;
  }

  @HostListener('document:click')
  onDocumentClick() {
    this.userMenuOpen = false;
  }

  navigateHome() {
    this.pcs.router.navigate(['dashboard']);
  }

  onSidebarToggle() {
    this.isSidebarCollapsed = !this.isSidebarCollapsed;
    localStorage.setItem('globalSidebarCollapsed', this.isSidebarCollapsed ? 'true' : 'false');
    this.sidebarToggle.emit(this.isSidebarCollapsed);
  }

  logout() {
    this.userMenuOpen = false;
    this.pcs.apiService.Logout({}, true).then((response) => this.onLogoutSucceeded());
  }

  onLogoutSucceeded() {
    this.pcs.clientSessionService.reset();
    this.pcs.router.navigate(['login']);
  }
}
